import { getHandlebarsSnippetTagFromString } from './getHandlebarsSnippetTagFromString';

export const isHandlebarsSnippetTag = (content: string): boolean =>
  !!getHandlebarsSnippetTagFromString(content);
